import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const PAGE_CTA_SCHEMA = Object.freeze({
  DESTINATION: '',
  MAX_VIEWS: -1,
});

const RECORD = generateSchema(PAGE_CTA_SCHEMA);
const KEYS: any = generateKeys(PAGE_CTA_SCHEMA);

export class PageCta extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get destination(): string {
    return this.get(KEYS.DESTINATION);
  }

  get maxViews(): number {
    return this.get(KEYS.MAX_VIEWS);
  }
}
